import { render, staticRenderFns } from "./LogoDribbbleIcon.vue?vue&type=template&id=a75151f0&"
import script from "./LogoDribbbleIcon.vue?vue&type=script&lang=js&"
export * from "./LogoDribbbleIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports